import ButtonStyles from 'styles/theme/Button';

export default class LoginAndPermissionDetailStyles {
    static page(theme) {
        return ({
            root: {
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                flex: 1,
                minHeight: 0,
                height: '100%',
                backgroundColor: theme.palette.background.default,
            },
            content: {
                flex: 1,
                minHeight: 0,
                overflow: 'auto',
                padding: theme.spacing(2),
            },
            topBar: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: theme.spacing(2),
                padding: theme.spacing(1.5, 2),
                borderBottom: `1px solid ${theme.palette.border.ghost}`,
                backgroundColor: theme.palette.background.white,
                flexShrink: 0,
            },
            userInfo: {
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing(1.5),
                minWidth: 0,
            },
            avatar: {
                width: 44,
                height: 44,
            },
            userText: {
                minWidth: 0,
            },
            userName: {
                fontSize: 18,
                fontWeight: 700,
                color: theme.palette.text.shark,
                lineHeight: 1.2,
            },
            userMeta: {
                fontSize: 13,
                color: theme.palette.text.waterloo,
            },
            actions: {
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing(1),
                flexShrink: 0,
            },
            topGrid: {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: theme.spacing(2),
                marginBottom: theme.spacing(2),
                [theme.breakpoints.down('sm')]: {
                    gridTemplateColumns: '1fr',
                },
            },
            card: {
                backgroundColor: theme.palette.background.white,
                border: `1px solid ${theme.palette.border.ghost}`,
                borderRadius: 8,
                padding: theme.spacing(2),
                minHeight: 280,
            },
            cardTitle: {
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing(1),
                fontSize: 13,
                fontWeight: 700,
                letterSpacing: 0.4,
                textTransform: 'uppercase',
                color: theme.palette.text.shark,
                marginBottom: theme.spacing(2),
                '& svg': {
                    color: theme.palette.text.curiousBlue,
                    fontSize: 18,
                },
            },
            fieldLabel: {
                fontSize: 12,
                fontWeight: 600,
                color: theme.palette.text.waterloo,
                marginBottom: theme.spacing(0.5),
            },
            fieldHint: {
                fontWeight: 400,
                color: theme.palette.text.secondary,
            },
            fieldGroup: {
                marginBottom: theme.spacing(1.5),
            },
            row: {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: theme.spacing(1.5),
            },
            checksRow: {
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing(2),
                marginBottom: theme.spacing(1.5),
                flexWrap: 'wrap',
            },
            checkItem: {
                margin: 0,
                display: 'flex',
                alignItems: 'center',
                paddingLeft: 0,
                '& .form-check-input': {
                    position: 'static',
                    marginTop: 0,
                    marginLeft: 0,
                    marginRight: theme.spacing(1),
                },
                '& .form-check-label': {
                    fontSize: 13,
                },
            },
            input: {
                width: '100%',
            },
            smallField: {
                '& .form-control, &.form-control': {
                    height: 31,
                    minHeight: 31,
                    fontSize: 13,
                    lineHeight: '21px',
                    padding: '4px 8px',
                },
                '& .input-group-append, & .input-group-prepend': {
                    height: 31,
                },
                '& .input-group-text': {
                    height: 31,
                    padding: '0 8px',
                    lineHeight: 1,
                    '& svg': {
                        fontSize: 18,
                    },
                },
                '&.input-group': {
                    borderRadius: '0.2rem',
                },
                '&.input-group:focus-within': {
                    boxShadow: '0 0 0 0.2rem rgba(0, 123, 255, 0.25)',
                },
                '&.input-group:focus-within .form-control, &.input-group:focus-within .input-group-text': {
                    borderColor: '#80bdff',
                    boxShadow: 'none',
                },
                '&.input-group:focus-within:has(.is-invalid)': {
                    boxShadow: '0 0 0 0.2rem rgba(220, 53, 69, 0.25)',
                },
                '&.input-group:focus-within:has(.is-invalid) .form-control, &.input-group:focus-within:has(.is-invalid) .input-group-text': {
                    borderColor: '#dc3545',
                },
            },
            inputIcon: {
                color: theme.palette.text.waterloo,
                backgroundColor: theme.palette.background.white,
                '& svg': {
                    fontSize: 18,
                },
            },
            visibilityButton: {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 18,
                height: 18,
                padding: 0,
                border: 0,
                background: 'transparent',
                color: 'inherit',
                cursor: 'pointer',
                lineHeight: 1,
            },
            passwordInput: {
                width: '100%',
            },
            fieldError: {
                marginTop: 4,
                fontSize: 12,
                color: theme.palette.error.main,
            },
            passwordTooltip: {
                maxWidth: 360,
                border: `1px solid ${theme.palette.text.curiousBlue}`,
                boxShadow: '0 4px 16px rgba(15, 23, 42, 0.12)',
            },
            passwordRules: {
                display: 'flex',
                flexDirection: 'column',
            },
            passwordRule: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: theme.spacing(1),
                padding: theme.spacing(1, 0),
                borderBottom: `1px solid ${theme.palette.border.ghost}`,
                fontSize: 13,
                lineHeight: 1.4,
                color: theme.palette.text.waterloo,
                '&:first-child': {
                    paddingTop: 0,
                },
                '&:last-child': {
                    borderBottom: 'none',
                    paddingBottom: 0,
                },
            },
            passwordRuleIconPass: {
                fontSize: 18,
                color: theme.palette.background.fruitSalad,
                flexShrink: 0,
                marginTop: 1,
            },
            passwordRuleIconFail: {
                fontSize: 18,
                color: theme.palette.text.statusGray,
                flexShrink: 0,
                marginTop: 1,
            },
            lotsLayout: {
                display: 'grid',
                gridTemplateColumns: '1fr 44px 1fr',
                gap: theme.spacing(1.5),
                alignItems: 'stretch',
                minHeight: 260,
            },
            lotPanel: {
                border: `1px solid ${theme.palette.border.ghost}`,
                borderRadius: 8,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                minHeight: 260,
                backgroundColor: theme.palette.background.white,
            },
            lotPanelAssigned: {
                border: `1px solid ${theme.palette.text.curiousBlue}`,
            },
            lotPanelTitle: {
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing(0.75),
                padding: theme.spacing(1, 1.25),
                borderBottom: `1px solid ${theme.palette.border.ghost}`,
                backgroundColor: theme.palette.background.athensGray,
                fontSize: 12,
                fontWeight: 700,
                color: theme.palette.text.shark,
                '& svg': {
                    fontSize: 16,
                    color: theme.palette.text.waterloo,
                },
            },
            lotPanelTitleAssigned: {
                backgroundColor: theme.palette.background.lavenderBlue,
                borderBottom: `1px solid ${theme.palette.text.curiousBlue}`,
                color: theme.palette.text.curiousBlue,
                '& svg': {
                    color: theme.palette.text.curiousBlue,
                },
            },
            lotPanelHeader: {
                padding: theme.spacing(1, 1.25),
                borderBottom: `1px solid ${theme.palette.border.ghost}`,
            },
            lotSearch: {
                width: '100%',
            },
            lotCheckbox: {
                marginBottom: 0,
                paddingLeft: 0,
                minHeight: '1rem',
                display: 'flex',
                alignItems: 'center',
                '& .form-check-input': {
                    position: 'static',
                    marginTop: 0,
                    marginLeft: 0,
                },
            },
            lotList: {
                flex: 1,
                overflow: 'auto',
                padding: theme.spacing(0.5, 0.75),
            },
            lotItem: {
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing(0.5),
                minHeight: 34,
                padding: theme.spacing(0, 0.5),
                borderRadius: 4,
            },
            lotItemSelected: {
                backgroundColor: theme.palette.background.lavenderBlue,
            },
            defaultBadge: {
                marginLeft: 'auto',
                padding: '1px 6px',
                borderRadius: 4,
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: 0.3,
                color: theme.palette.text.curiousBlue,
                border: `1px solid ${theme.palette.text.curiousBlue}`,
                backgroundColor: theme.palette.background.white,
            },
            lotTransfer: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: theme.spacing(1),
                alignSelf: 'center',
            },
            transferButton: {
                width: 36,
                height: 36,
                minWidth: 36,
                padding: 0,
                borderRadius: 6,
                border: `1px solid ${theme.palette.border.ghost}`,
                backgroundColor: theme.palette.background.white,
                color: theme.palette.text.waterloo,
                boxSizing: 'border-box',
                '&:hover': {
                    backgroundColor: theme.palette.background.athensGray,
                },
                '& svg': {
                    fontSize: 20,
                },
            },
            transferButtonPrimary: {
                border: `1px solid ${theme.palette.text.curiousBlue}`,
                backgroundColor: theme.palette.text.curiousBlue,
                color: theme.palette.text.white,
                '&:hover': {
                    backgroundColor: theme.palette.text.curiousBlue,
                    opacity: 0.92,
                },
            },
            transferDoubleIcon: {
                display: 'inline-flex',
                alignItems: 'center',
                '& svg': {
                    fontSize: 18,
                    marginLeft: -8,
                },
                '& svg:first-child': {
                    marginLeft: 0,
                },
            },
            permissionsCard: {
                backgroundColor: theme.palette.background.white,
                border: `1px solid ${theme.palette.border.ghost}`,
                borderRadius: 8,
                overflow: 'hidden',
            },
            permissionsHeader: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: theme.spacing(2),
                padding: theme.spacing(1.25, 2),
                backgroundColor: theme.palette.background.pickledBluewood,
                color: theme.palette.text.white,
                flexWrap: 'wrap',
            },
            permissionsTitle: {
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing(1),
                fontSize: 13,
                fontWeight: 700,
                letterSpacing: 0.4,
                textTransform: 'uppercase',
            },
            permissionsTools: {
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing(1.5),
            },
            permissionFilter: {
                width: 240,
                borderRadius: 8,
                '& .form-control, & .input-group-text': {
                    height: 31,
                    backgroundColor: 'rgba(255, 255, 255, 0.14)',
                    border: 'none',
                    color: theme.palette.text.white,
                },
                '& .form-control': {
                    boxShadow: 'none',
                    '&::placeholder': {
                        color: 'rgba(255, 255, 255, 0.7)',
                    },
                    '&:focus': {
                        backgroundColor: 'rgba(255, 255, 255, 0.22)',
                        color: theme.palette.text.white,
                        boxShadow: 'none',
                    },
                },
                '&:focus-within .input-group-text': {
                    backgroundColor: 'rgba(255, 255, 255, 0.22)',
                },
                '& .input-group-text': {
                    paddingRight: 4,
                },
                '& .MuiSvgIcon-root': {
                    fontSize: 18,
                },
            },
            checkAll: {
                margin: 0,
                display: 'flex',
                alignItems: 'center',
                paddingLeft: 0,
                color: theme.palette.text.white,
                '& .form-check-input': {
                    position: 'static',
                    marginTop: 0,
                    marginLeft: 0,
                    marginRight: theme.spacing(1),
                },
                '& .form-check-label': {
                    fontSize: 13,
                    color: theme.palette.text.white,
                },
            },
            permissionsBody: {
                padding: theme.spacing(1.5),
                display: 'flex',
                flexDirection: 'column',
                gap: theme.spacing(1.25),
                backgroundColor: theme.palette.background.default,
            },
            category: {
                border: `1px solid ${theme.palette.border.ghost}`,
                borderRadius: 8,
                overflow: 'hidden',
                backgroundColor: theme.palette.background.white,
            },
            categoryHeader: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: theme.spacing(1),
                padding: theme.spacing(0.5, 1.5),
                backgroundColor: theme.palette.background.lavender,
                cursor: 'pointer',
                userSelect: 'none',
            },
            categoryHeaderLeft: {
                display: 'flex',
                alignItems: 'center',
                minWidth: 0,
                flex: 1,
            },
            categoryCheckWrap: {
                display: 'flex',
                alignItems: 'center',
                minWidth: 0,
            },
            categoryCheck: {
                display: 'flex',
                alignItems: 'center',
                paddingLeft: 0,
                '& .form-check-input': {
                    position: 'static',
                    marginTop: 0,
                    marginLeft: 0,
                    marginRight: theme.spacing(1),
                },
                '& .form-check-label': {
                    display: 'inline-flex',
                    alignItems: 'center',
                },
            },
            categoryHeaderLabel: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: theme.spacing(0.75),
            },
            categoryIcon: {
                color: theme.palette.text.curiousBlue,
                fontSize: 18,
            },
            categoryTitle: {
                fontSize: 13,
                fontWeight: 700,
                letterSpacing: 0.3,
                textTransform: 'uppercase',
                color: theme.palette.text.curiousBlue,
            },
            categoryTitleOnly: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: theme.spacing(0.75),
                paddingLeft: 4,
                minHeight: 32,
            },
            categoryBody: {
                padding: theme.spacing(0.5, 1.5, 1.5),
                display: 'grid',
                gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
                gap: theme.spacing(0.5, 1.5),
                [theme.breakpoints.down('md')]: {
                    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                },
                [theme.breakpoints.down('sm')]: {
                    gridTemplateColumns: '1fr',
                },
            },
            permissionItem: {
                margin: 0,
                '& .form-check-label': {
                    fontSize: 13,
                },
            },
            loadingBox: {
                minHeight: 240,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            },
            ...ButtonStyles.getStyle(theme),
        });
    }
}
